import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzButton',
  props: {
    disabled: {
      type: Boolean
    },
    color: null,
    link: null
  },
  setup: function setup(__props) {
    var props = __props;
    var computedClasses = computed(function () {
      return {
        'is-disabled--button': !props.link && props.disabled,
        'is-disabled--link': props.link && props.disabled,
        'color-primary': props.color === 'primary',
        'color-secondary': props.color === 'secondary',
        'color-tertiary': props.color === 'tertiary'
      };
    });
    return {
      __sfc: true,
      props: props,
      computedClasses: computedClasses
    };
  }
});